/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    ServiceEventCreateDto,
    ServiceEventDto,
    ServiceEventUpdateDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    ServiceEventCreateDtoFromJSON,
    ServiceEventCreateDtoToJSON,
    ServiceEventDtoFromJSON,
    ServiceEventDtoToJSON,
    ServiceEventUpdateDtoFromJSON,
    ServiceEventUpdateDtoToJSON,
} from "../models/index";

export interface CompleteServiceEventRequest {
    serviceEventId: number;
}

export interface CreateServiceEventRequest {
    body: ServiceEventCreateDto;
}

export interface DeleteServiceEventRequest {
    serviceEventId: number;
}

export interface GetServiceEventRequest {
    serviceEventId: number;
}

export interface UpdateServiceEventRequest {
    serviceEventId: number;
    body: ServiceEventUpdateDto;
}

/**
 *
 */
export class ServiceEventsApi extends runtime.BaseAPI {
    /**
     * Mark a service event as complete
     */
    async completeServiceEventRaw(
        requestParameters: CompleteServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["serviceEventId"] == null) {
            throw new runtime.RequiredError(
                "serviceEventId",
                'Required parameter "serviceEventId" was null or undefined when calling completeServiceEvent().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/service-events/{serviceEventId}/complete`.replace(
                    `{${"serviceEventId"}}`,
                    encodeURIComponent(
                        String(requestParameters["serviceEventId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Mark a service event as complete
     */
    async completeServiceEvent(
        requestParameters: CompleteServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.completeServiceEventRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create a new service event
     */
    async createServiceEventRaw(
        requestParameters: CreateServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling createServiceEvent().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/service-events`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: ServiceEventCreateDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a new service event
     */
    async createServiceEvent(
        requestParameters: CreateServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createServiceEventRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete a service event
     */
    async deleteServiceEventRaw(
        requestParameters: DeleteServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["serviceEventId"] == null) {
            throw new runtime.RequiredError(
                "serviceEventId",
                'Required parameter "serviceEventId" was null or undefined when calling deleteServiceEvent().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/service-events/{serviceEventId}`.replace(
                    `{${"serviceEventId"}}`,
                    encodeURIComponent(
                        String(requestParameters["serviceEventId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete a service event
     */
    async deleteServiceEvent(
        requestParameters: DeleteServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteServiceEventRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a single service event by ID
     */
    async getServiceEventRaw(
        requestParameters: GetServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ServiceEventDto>> {
        if (requestParameters["serviceEventId"] == null) {
            throw new runtime.RequiredError(
                "serviceEventId",
                'Required parameter "serviceEventId" was null or undefined when calling getServiceEvent().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/service-events/{serviceEventId}`.replace(
                    `{${"serviceEventId"}}`,
                    encodeURIComponent(
                        String(requestParameters["serviceEventId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ServiceEventDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get a single service event by ID
     */
    async getServiceEvent(
        requestParameters: GetServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ServiceEventDto> {
        const response = await this.getServiceEventRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData endpoint for listing/filtering service events
     */
    async getServiceEventsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<ServiceEventDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/service-events-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(ServiceEventDtoFromJSON),
        );
    }

    /**
     * OData endpoint for listing/filtering service events
     */
    async getServiceEventsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<ServiceEventDto>> {
        const response = await this.getServiceEventsODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update an existing service event (date + tickets only)
     */
    async updateServiceEventRaw(
        requestParameters: UpdateServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["serviceEventId"] == null) {
            throw new runtime.RequiredError(
                "serviceEventId",
                'Required parameter "serviceEventId" was null or undefined when calling updateServiceEvent().',
            );
        }

        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling updateServiceEvent().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/service-events/{serviceEventId}`.replace(
                    `{${"serviceEventId"}}`,
                    encodeURIComponent(
                        String(requestParameters["serviceEventId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: ServiceEventUpdateDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update an existing service event (date + tickets only)
     */
    async updateServiceEvent(
        requestParameters: UpdateServiceEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateServiceEventRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
